import AppConfig from "../app.config";
import { getPdfToken } from "../api-helpers/api-pdf";

let pdfUrl = AppConfig.PROD_PDF_URL;
if (window.location.origin.indexOf(AppConfig.LOCAL_URL) > -1) {
  pdfUrl = AppConfig.LOCAL_PDF_URL;
} else if (window.location.origin.indexOf(AppConfig.STAGING_URL) > -1) {
  pdfUrl = AppConfig.STAGING_PDF_URL;
}

export default {
  state: {
    isGettingPdfUrl: false,
    pdfUrl: null
  },
  mutations: {
    setIsGettingPdfUrl(state, bool) {
      state.isGettingPdf = bool;
    },
    setPdfUrl(state, pdf) {
      state.pdf = pdf;
    }
  },
  actions: {
    async getPdfUrl({ state, commit, dispatch }, data) {
      let url = state.pdfUrl;
      if (!state.isGettingPdfUrl && data && data.type && data.type_id) {
        commit("setIsGettingPdfUrl", true);

        const statusAndToken = await getPdfToken(data);
        url = `${pdfUrl}/?token=${statusAndToken.pdfToken}`;
        commit("setPdfUrl", url);

        dispatch("handleApiResponse", {
          responseStatus: statusAndToken.status,
          errorText: "An error occurred while attempting to generate PDF.",
          afterSuccessFunction: () => {
            const win = window.open(url);
            win.focus();
          }
        });

        commit("setIsGettingPdfUrl", false);
      }
      return url;
    }
  }
};
